import React from 'react';


const CategoryChips = ({ categories, selectedCategory, onCategoryChange }) => {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
      <button
        onClick={() => onCategoryChange('all')}
        className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all ${
          selectedCategory === 'all' ?'bg-accent text-accent-foreground shadow-md' :'bg-card text-foreground border border-border hover:border-accent'
        }`}
      >
        All Posts
      </button>
      {categories?.map((category) => (
        <button
          key={category?.id}
          onClick={() => onCategoryChange(category?.id)}
          className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all flex items-center gap-2 ${
            selectedCategory === category?.id
              ? 'bg-accent text-accent-foreground shadow-md'
              : 'bg-card text-foreground border border-border hover:border-accent'
          }`}
        >
          <span>{category?.name}</span>
          <span className="text-xs opacity-70">({category?.count})</span>
        </button>
      ))}
    </div>
  );
};

export default CategoryChips;